import { render, staticRenderFns } from "./AccountSettingAppColors.vue?vue&type=template&id=63eca37d"
import script from "./AccountSettingAppColors.vue?vue&type=script&lang=js"
export * from "./AccountSettingAppColors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports